import PropTypes from 'prop-types';
import React from 'react';
import { Text, Amount } from 'primitive-components';
import { Grid, Cell } from 'layout-core-components';

import SegmentInputContainer from './SegmentInputContainer';

/**
 * @param {Object.<string, any>} props Component props
 * @param {string} props.clientId The client's id
 * @param {Array.<Object>} props.clientSegmentCategories The categories a user has defined for
 * segmenting transactions. See GET_CLIENT_SEGMENT_CATEGORIES for shape.
 * @param {Array} props.dataEntryIds
 * @param {Array.<Object>} props.dataEntrySegmentDetails The segments a user has allocated for
 * this data entry. See GET_DATA_ENTRY_SEGMENTS for shape.
 * @param {string} props.ledgerAccountId The ledger name
 * @param {string} props.ledgerName The ledger name
 * @param {string} props.totalLedgerAmount The total amount of all data entries belonging to this ledger
 * @param {string} props.transactionId
 *
 * @return {ReactNode}
 */
export default function SegmentAllocator({
  clientId,
  clientSegmentCategories,
  dataEntryIds,
  dataEntrySegmentDetails,
  ledgerAccountId,
  ledgerName,
  totalLedgerAmount,
  transactionId,
}) {
  return (
    <Grid column rowSpacing="medium">
      <Cell size="auto">
        <Grid row="auto min-content">
          <Text weight="bold">{ledgerName}</Text>
          <Amount weight="bold" amount={totalLedgerAmount} inCents />
        </Grid>
      </Cell>

      {clientSegmentCategories.map(category => (
        <Cell key={category.id} size="auto">
          <SegmentInputContainer
            category={category}
            clientId={clientId}
            dataEntryIds={dataEntryIds}
            dataEntrySegmentDetails={dataEntrySegmentDetails}
            ledgerAccountId={ledgerAccountId}
            transactionId={transactionId}
          />
        </Cell>
      ))}
    </Grid>
  );
}

SegmentAllocator.propTypes = {
  clientId: PropTypes.string.isRequired,
  clientSegmentCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataEntryIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  dataEntrySegmentDetails: PropTypes.object.isRequired, // eslint-disable-line
  ledgerAccountId: PropTypes.string.isRequired,
  ledgerName: PropTypes.string.isRequired,
  totalLedgerAmount: PropTypes.number.isRequired,
  transactionId: PropTypes.string.isRequired,
};
